<template>
  <div>
    <div id="footer_left">
      <!-- <span>审批流程:</span> -->
      <div class="footer_left_content">
        <div v-for="(item,index) in rowData" :key="index" :style="{minWidth: getMyStyle(item)}">
          <span class="left_1">
            <b v-if="item.conditions===0">普通:</b>
            <b v-if="item.conditions===1">会签:</b>
            <b v-if="item.conditions===2">或签:</b>
            <!-- 首先判断是角色、人员、职务，再次判断是单个人还是多个人(数组) -->
            <span v-if="item.checkPersonId">
              <span v-if="Array.isArray(item.checkPersonName)">
                <span class="personClass nameClass" v-for="(item2, index2) in item.checkPersonName" :key="index2" style="margin-left:8px;">
                  {{item2}}
                </span>
              </span>
              <span v-else>
                <span class="personClass nameClass">{{item.checkPersonName}}</span>
              </span>
            </span>
            <span v-if="item.checkRoleId">
              <span v-if="Array.isArray(item.checkRoleName)">
                <span class="roleClass nameClass" v-for="(item2, index2) in item.checkRoleName" :key="index2" style="margin-left:8px;">
                  {{item2}}
                </span>
              </span>
              <span v-else>
                <span class="roleClass nameClass">{{item.checkRoleName}}</span>
              </span>
            </span>
            <span v-if="item.checkDutyId">
              <span v-if="Array.isArray(item.checkDutyName)">
                <span class="dutyClass nameClass" v-for="(item3, index3) in item.checkDutyName" :key="index3" style="margin-left:8px;">
                  {{item3}}
                </span>
              </span>
              <span v-else>
                <span class="dutyClass nameClass" style="margin-left:8px;">{{item.checkDutyName}}</span>
              </span>
            </span>
          </span>
          <a-icon v-if="index < rowData.length - 1" theme="filled" type="right-circle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkFlow',
  props: {
    rowData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      approverData: [
        {
          name: ['王明', '刘涛成'],
          status: 2
        },
        {
          name: ['江明', '刘微微'],
          status: 1
        }
      ],
      checkData: this.rowData
    }
  },
  watch: {
    rowData (valList) {
      if (valList) {
        valList.forEach(item => {
          if (item.checkRoleName && item.checkRoleName.indexOf(',') > -1) {
            item.checkRoleName = item.checkRoleName.split(',')
          }
          if (item.checkPersonName && item.checkPersonName.indexOf(',') > -1) {
            item.checkPersonName = item.checkPersonName.split(',')
          }
          if (item.checkDutyName && item.checkDutyName.indexOf(',') > -1) {
            item.checkDutyName = item.checkDutyName.split(',')
          }
        })
      }
      this.checkData = valList
    }
  },
  methods: {
    getMyStyle (val) {
      let lengthVal = 0
      if (val.checkRoleName) {
        if (Array.isArray(val.checkRoleName)) {
          lengthVal += val.checkRoleName.length
        } else {
          lengthVal += 1
        }
      }
      if (val.checkPersonName) {
        if (Array.isArray(val.checkPersonName)) {
          lengthVal += val.checkPersonName.length
        } else {
          lengthVal += 1
        }
      }
      if (val.checkDutyName) {
        if (Array.isArray(val.checkDutyName)) {
          lengthVal += val.checkDutyName.length
        } else {
          lengthVal += 1
        }
      }
      return lengthVal * 70 + 105 + 'px'
    }
  }
}
</script>

<style scoped>
#footer_left{
  padding: 16px 0;
  overflow-x: auto;
  }
    .footer_left_content{
      display: flex;
    }
      .left_1{
        margin: 0 10px;
        border: 1px dashed #ccc;
        margin-left: 10px;
        padding: 10px;
      }
    .nameClass{
      font-size: 14px;
      color: #ffffff;
      padding: 6px 4px;
      border-radius: 6px;
    }
      .personClass{
        background-color: #5585ac;
      }
      .roleClass{
        background-color: #42b983;
      }
      .dutyClass{
        background-color: #b37bfd;
      }
</style>



// WEBPACK FOOTER //
// src/views/common/checkFlow.vue